import { render, staticRenderFns } from "./GLItem.vue?vue&type=template&id=7734aab2&"
import script from "./GLItem.vue?vue&type=script&lang=js&"
export * from "./GLItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports